import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { IconButton, Input, type InputProps } from '@/components/ui'

export type PasswordInputProps = Omit<InputProps, 'type' | 'trailing'>

/** A password field with a reveal toggle. The toggle is a sibling control, never a submit. */
export function PasswordInput(props: PasswordInputProps) {
  const [visible, setVisible] = useState(false)

  return (
    <Input
      {...props}
      type={visible ? 'text' : 'password'}
      trailing={
        <IconButton
          size="sm"
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-pressed={visible}
          onClick={() => setVisible((current) => !current)}
        >
          {visible ? (
            <EyeOff className="h-4 w-4" aria-hidden="true" />
          ) : (
            <Eye className="h-4 w-4" aria-hidden="true" />
          )}
        </IconButton>
      }
    />
  )
}
